import styled from "styled-components";

// Escala de calor quente (amarelo pálido → laranja → vermelho), como é habitual
// em mapas de calor. Interpola entre as paradas conforme a intensidade t∈[0,1].
const HEAT_STOPS: [number, number, number][] = [
  [254, 240, 138], // baixo  (#FEF08A)
  [249, 115, 22], // médio  (#F97316)
  [185, 28, 28], // alto   (#B91C1C)
];
export function heatColor(t: number): string {
  const x = Math.max(0, Math.min(1, t));
  const seg = x < 0.5 ? 0 : 1;
  const u = x < 0.5 ? x / 0.5 : (x - 0.5) / 0.5;
  const a = HEAT_STOPS[seg];
  const b = HEAT_STOPS[seg + 1];
  const c = a.map((v, i) => Math.round(v + (b[i] - v) * u));
  return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
}

export const Scroll = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid var(--border);
  border-radius: var(--border-radius-sm, 0.5rem);
`;

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  margin: 0;
  font-size: 0.8125rem;

  th,
  td {
    text-align: center;
    padding: 0.4rem 0.55rem;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: var(--surface-2);
    color: var(--text-muted);
    font-weight: 600;
    border-bottom: 1px solid var(--border);
  }

  tbody th {
    position: sticky;
    left: 0;
    z-index: 1;
    background: var(--surface);
    color: var(--text-primary);
    font-weight: 700;
    border-right: 1px solid var(--border);
  }

  thead th:first-child {
    left: 0;
    z-index: 3;
    text-align: left;
    background: var(--surface-2);
  }

  tbody tr:hover th {
    background: var(--surface-2);
  }

  tfoot th,
  tfoot td {
    position: sticky;
    bottom: 0;
    font-weight: 700;
    color: var(--text-primary);
    background: var(--surface-2);
    border-top: 1px solid var(--border);
  }

  tfoot th:first-child {
    left: 0;
    z-index: 2;
    text-align: left;
  }
`;

// Célula de calor: escala quente amarelo→vermelho conforme a intensidade — a
// cor calculada por linha não tem classe utilitária equivalente.
export const Cell = styled.td<{ $t: number; $filled: boolean }>`
  background: ${({ $filled, $t }) => ($filled ? heatColor($t) : "transparent")};
  color: ${({ $filled, $t }) => ($filled && $t > 0.62 ? "#fff" : "var(--text-primary)")};
  font-weight: ${({ $filled, $t }) => ($filled && $t > 0.35 ? 600 : 400)};
  transition: outline 0.12s ease;

  &:hover {
    outline: 2px solid var(--danger, #dc2626);
    outline-offset: -2px;
  }
`;

export const Empty = styled.span`
  color: var(--text-label);
  opacity: 0.5;
`;

// Colunas de resumo (% do total, ticket médio): número + barrinha.
export const SummaryCell = styled.td`
  min-width: 104px;
  text-align: left !important;
  vertical-align: middle;
`;

export const CellNum = styled.div`
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  margin-bottom: 3px;
`;

export const Track = styled.div`
  height: 5px;
  border-radius: 3px;
  background: var(--surface-3, #eef0f2);
  overflow: hidden;
`;

export const Fill = styled.div<{ $w: number; $color: string }>`
  height: 100%;
  width: ${({ $w }) => Math.max(0, Math.min(100, $w))}%;
  background: ${({ $color }) => $color};
  border-radius: 3px;
`;

export const Chip = styled.li`
  display: inline-flex;
  align-items: baseline;
  gap: 0.35rem;
  padding: 0.3rem 0.6rem;
  border-radius: 999px;
  background: rgba(var(--primary-rgb), 0.1);
  border: 1px solid rgba(var(--primary-rgb), 0.25);
  font-size: 0.8125rem;
  line-height: 1.2;

  b {
    color: var(--primary);
    font-weight: 700;
  }
  small {
    color: var(--text-muted);
  }
`;

export const LegendBar = styled.span`
  display: inline-block;
  width: 80px;
  height: 0.5rem;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    rgb(254, 240, 138),
    rgb(249, 115, 22),
    rgb(185, 28, 28)
  );
`;
